import React from "react";
import "./Text.css";

/**
 * Typography primitive — one place for brand type, so screens stop hand-rolling
 * `fontSize`/`fontFamily`. Color follows the surface (--on-surface) unless a
 * tone is given.
 *
 * Props:
 *   variant: "display" | "h1" | "h2" | "h3" | "eyebrow" | "body" | "caption" | "code"
 *   tone:    "default" | "muted" | "accent"
 *   as:      element override (defaults per variant)
 *   align, weight: convenience overrides
 */
const VARIANT_CLASS = {
  display: "gx-t-display",
  h1: "gx-t-h1",
  h2: "gx-t-h2",
  h3: "gx-t-h3",
  eyebrow: "gx-t-eyebrow",
  body: "gx-t-body",
  caption: "gx-t-caption",
  code: "gx-t-code",
};
const TONE_CLASS = { default: "", muted: "gx-t-muted", accent: "gx-t-accent" };
const DEFAULT_TAG = {
  display: "div", h1: "h1", h2: "h2", h3: "h3",
  eyebrow: "div", body: "p", caption: "span", code: "code",
};

const Text = ({
  variant = "body",
  tone = "default",
  as,
  align,
  weight,
  className = "",
  style,
  children,
  ...rest
}) => {
  const Tag = as || DEFAULT_TAG[variant] || "span";
  return (
    <Tag
      className={`gx-text ${VARIANT_CLASS[variant] || VARIANT_CLASS.body} ${TONE_CLASS[tone] || ""} ${className}`}
      style={{ textAlign: align, fontWeight: weight, ...style }}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export default Text;
